export default password => {
    if (password.length < 8) return false
    // Minimum of 1 Upper case Letter and 1 lower case and 1 number
    const validatePassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,}$/
    if(false === validatePassword.test(password))
        return false

    return true
}